import userCard from './index.vue'
userCard.install = Vue => Vue.component(userCard.name, userCard)
export default userCard
